import { render } from "./MedicalCertificate.vue?vue&type=template&id=fd340b0a&scoped=true"
import script from "./MedicalCertificate.vue?vue&type=script&lang=js"
export * from "./MedicalCertificate.vue?vue&type=script&lang=js"

import "./MedicalCertificate.vue?vue&type=style&index=0&id=fd340b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd340b0a"]])

export default __exports__